import { mapName } from '../game/maps';
import { discord, helpOpen, isHost, lobby, net, netStatus, participants, results, screen, self, sound, speaking } from '../store';
import { Avatar } from './common';

const MODE_LABEL = { versus: 'Versus', brawl: 'Brawl', coop: 'Co-op Siege', campaign: 'Campaign' } as const;

export function TopBar() {
  const l = lobby.value;
  const inMatch = screen.value === 'match';
  const people = l?.players.filter((p) => p.connected) ?? participants.value.map((p) => ({ id: p.id, name: p.name, avatarUrl: p.avatarUrl }));
  const shown = people.slice(0, 6);
  const extra = people.length - shown.length;
  const playing = l?.players.filter((p) => !p.spectator && p.connected).length ?? 0;

  return (
    <header class="topbar">
      <a class="brand" href="#" onClick={(e) => { e.preventDefault(); if (!inMatch) screen.value = 'lobby'; }}>
        <span class="brand-mark" aria-hidden="true" />
        <span class="brand-text">Cratered</span>
      </a>
      <div class="topbar-center">
        {l && (
          <span class="chip">
            <span class="dot" style={{ background: netStatus.value === 'online' ? 'var(--good)' : 'var(--warn)' }} />
            {MODE_LABEL[l.settings.mode]}
            <span class="optional muted">· {mapName(l.settings.map)}</span>
            <span class="muted num">· {playing} playing</span>
          </span>
        )}
      </div>
      <div class="topbar-right">
        <div class="avatar-stack" aria-label={`${people.length} in the activity`}>
          {shown.map((p) => (
            <Avatar key={p.id} name={p.name} url={p.avatarUrl} speaking={speaking.value.has(p.id)} />
          ))}
          {extra > 0 && <span class="more num">+{extra}</span>}
        </div>
        <button class="btn" onClick={() => discord.value?.openInviteDialog()} title="Invite friends" aria-label="Invite friends">
          <span aria-hidden="true">＋</span> <span class="btn-label">Invite</span>
        </button>
        {!inMatch && (
          <button
            class="btn ghost"
            aria-pressed={screen.value === 'locker'}
            // From the results screen the Locker leads back to it: the map vote lives there.
            onClick={() => (screen.value = screen.value === 'locker' ? (l?.phase === 'results' && results.value ? 'results' : 'lobby') : 'locker')}
          >
            Locker
          </button>
        )}
        <button
          class="btn icon ghost"
          aria-label={sound.value ? 'Mute sounds' : 'Unmute sounds'}
          aria-pressed={!sound.value}
          title={sound.value ? 'Sound on' : 'Sound off'}
          onClick={() => (sound.value = !sound.value)}
        >
          <span aria-hidden="true">{sound.value ? '🔊' : '🔇'}</span>
        </button>
        <button class="btn icon ghost" aria-label="How to play" onClick={() => (helpOpen.value = !helpOpen.value)}>
          ?
        </button>
        {self.value && !l && net.value && <span class="muted" style={{ fontSize: 12 }}>connecting…</span>}
      </div>
    </header>
  );
}
